var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 18.6666H12.5C12.25 18.6666 12 18.9583 12 19.2083V22.1666C12 22.4166 12.25 22.6666 12.5 22.6666H13.4583C13.7083 22.6666 14 22.4166 14 22.1666V19.2083C14 18.9583 13.7083 18.6666 13.4583 18.6666ZM16.4583 15.9999H15.5C15.25 15.9999 15 16.2916 15 16.5416V22.1666C15 22.4166 15.25 22.6666 15.5 22.6666H16.4583C16.7083 22.6666 17 22.4166 17 22.1666V16.5416C17 16.2916 16.7083 15.9999 16.4583 15.9999ZM18.5 22.6666H19.4583C19.7083 22.6666 20 22.4166 20 22.1666V17.8749C20 17.6249 19.7083 17.3333 19.4583 17.3333H18.5C18.25 17.3333 18 17.6249 18 17.8749V22.1666C18 22.4166 18.25 22.6666 18.5 22.6666ZM23.375 9.41659L19.875 5.95825C19.5 5.58325 19 5.33325 18.5 5.33325H9.95833C8.875 5.37492 8 6.24992 8 7.37492V24.7083C8 25.7916 8.875 26.6666 9.95833 26.6666H21.9583C23.0833 26.6666 24 25.7916 24 24.7083V10.8333C24 10.3333 23.75 9.79159 23.375 9.41659ZM18.625 7.49992L21.8333 10.7083H18.625V7.49992ZM22 24.7083H9.95833V7.37492H16.625V11.7083C16.625 12.2499 17.0833 12.7083 17.625 12.7083H22V24.7083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedReports);
export default __webpack_public_path__ + "static/media/Selected Reports.ee3624182ec469893a036f38bd6346ec.svg";
export { ForwardRef as ReactComponent };